<input
  type="text"
  [placeholder]="placeholder"
  (input)="onInputChange($event)"
  class="debounce-input"
/>
